var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, TableCell, TableHead, TableRow } from '@mui/material';
import useCustomTranslation from '@libs/hooks/useCustomTranslation';
var BaseTableHead = function (props) {
    var indeterminate = props.indeterminate, checked = props.checked, ordinalNumber = props.ordinalNumber, columns = props.columns, hasCheckBox = props.hasCheckBox, customStyle = props.customStyle, isLoading = props.isLoading, handleSelectdAllClick = props.handleSelectdAllClick;
    var t = useCustomTranslation();
    return (_jsx(TableHead, { sx: __assign({}, (customStyle && __assign({}, customStyle))), children: _jsxs(TableRow, { children: [hasCheckBox && (_jsx(TableCell, { padding: 'checkbox', children: _jsx(Checkbox, { color: 'primary', indeterminate: !isLoading && indeterminate, checked: !isLoading && checked, onChange: handleSelectdAllClick, inputProps: {
                            'aria-label': 'select all desserts'
                        } }) })), ordinalNumber && _jsx(TableCell, { children: t('L000235') }), columns.map(function (column) { return (_jsx(TableCell, { sx: __assign({}, (column.customStyle && __assign({}, column.customStyle))), children: column.label }, column.id)); })] }) }));
};
export default BaseTableHead;
